module.exports = __webpack_public_path__ + "img/ring_r_i_null_0.fd537f9d.png";